import { useState, useEffect } from 'react';

import logger from '../../../config/app.logger';
import { getExtendedLogger } from '../../Logger';

import { LOGGER_NAME } from '../config/constants';

import { getHighResolutionTime } from '../../../utils';
//@ts-ignore
import { noop } from '@mindtickle/utils';

const log = getExtendedLogger(LOGGER_NAME, logger);

const useDynamicScript = ({
  url,
  alreadyInitialised = false,
  onLoad = noop,
}: {
  url?: string;
  alreadyInitialised?: boolean;
  onLoad?: Function;
}) => {
  const [ready, setReady] = useState(alreadyInitialised);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!url || alreadyInitialised) {
      return;
    }

    const element = document.createElement('script');

    element.src = url;
    element.type = 'text/javascript';
    element.async = true;

    setReady(false);
    setFailed(false);

    const startLoadTime = getHighResolutionTime();
    element.onload = () => {
      onLoad(getHighResolutionTime() - startLoadTime);
      log(`Dynamic Script Loaded: ${url}`);
      setReady(true);
    };

    element.onerror = () => {
      log(`Dynamic Script Error: ${url}`);
      setReady(false);
      setFailed(true);
    };

    document.head.appendChild(element);

    return () => {
      log(`Dynamic Script Removed: ${url}`);
      document.head.removeChild(element);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    ready,
    failed,
  };
};

export default useDynamicScript;
